export const userRoles = {
  csqadmin: {
    home: {
      add: {
        addTeacher: true,
        addStudent: true,
        addSchool: false,
        addEvent: false,
        addCSQAdmin: false,

      }
    },
    userManagement: {
      add: {
        addCSQUser: false,
        addTeacher: true,
        addStudent: true,
        addAdmin: false,
        addSuperAdmin: false,
      },
      export: true,
      listItem: {
        view: true,
        edit: true,
        delete: false,
        statusChange: true
      }
    },
    eventManagement: {
      createEvent: true,
      export: true,
      listItem: {
        view: true,
        edit: true,
        delete: true,
        statusChange: true
      }
    },
    eventManagementView: {
      shareEmail: true,
      syncWithAsana: true,
      statusChange: true,
      edit: true,
      assignStudent: true,
      studentList: {
        edit: true,
        statusChange: true,
        mediaConsent: true,
      }
    },
    eventType: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    mccEventPartner: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    focusArea: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    audiance: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    region: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    school: {
      addNew: true,
      export: true,
      listItem: {
        edit: true,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    schoolView: {
      edit: true,
      addItem: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
      }
    },
    teacher: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: true,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    teacherView: {
      edit: true,
      listItem: {
        view: true,
      }
    },
    student: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: true,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    studentView: {
      edit: true,
      schoolView: true,
      changeMediaConsent: true
    },
    report: {
      share: true,
      reportDashboard: true,
      eventTypeReport: true,
      eventReport: true,
      managerActivity: true,
      industryPartner: true,
      mccEvents: true,
      schoolEngagement: true,
    },
    csqTeam: {
      addNew: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    settings: {
      manage: {
        view: true,
        edit: true
      },
      reset: {
        view: true,
        edit: true
      }
    },
    faqCategories: {
      addNew: false,
      listItem: {
        edit: false,
        delete: false,
      }
    },
  },

  csquser: {
    home: {
      add: {
        addTeacher: true,
        addStudent: true,
        addSchool: false,
        addEvent: false,
        addCSQAdmin: false,
      }
    },
    userManagement: {
      add: {
        addCSQUser: false,
        addTeacher: false,
        addStudent: false,
        addAdmin: false,
        addSuperAdmin: false,
      },
      export: true,
      listItem: {
        view: true,
        edit: false,
        delete: false,
        statusChange: true
      }
    },
    eventManagement: {
      createEvent: true,
      export: true,
      listItem: {
        view: true,
        edit: true,
        delete: true,
        statusChange: false
      }
    },
    eventManagementView: {
      shareEmail: true,
      syncWithAsana: true,
      statusChange: true,
      edit: true,
      assignStudent: true,
      studentList: {
        edit: true,
        statusChange: true,
        mediaConsent: false,
      }
    },
    eventType: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    mccEventPartner: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    focusArea: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    audiance: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    region: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    school: {
      addNew: false,
      export: true,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: false
      }

    },
    schoolView: {
      edit: false,
      addItem: false,
      listItem: {
        edit: false,
        view: true,
        delete: false,
      }
    },
    teacher: {
      addNew: true,
      export: true,
      bulkUpload: false,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: false
      },
    },
    teacherView: {
      edit: false,
      listItem: {
        view: false,
      }
    },
    student: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: false
      }
    },
    studentView: {
      edit: false,
      schoolView: true,
      changeMediaConsent: true
    },
    report: {
      share: true,
      reportDashboard: true,
      eventTypeReport: true,
      eventReport: true,
      managerActivity: false,
      industryPartner: true,
      mccEvents: false,
      schoolEngagement: true,
    },
    csqTeam: {
      addNew: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    settings: {
      manage: {
        view: true,
        edit: true
      },
      reset: {
        view: true,
        edit: true
      }
    },
    faqCategories: {
      addNew: false,
      listItem: {
        edit: false,
        delete: false,
      }
    },
  },

  superadmin: {
    home: {
      add: {
        addTeacher: true,
        addStudent: true,
        addSchool: true,
        addEvent: true,
        addCSQAdmin: true,
      }
    },
    userManagement: {
      add: {
        addCSQUser: true,
        addTeacher: true,
        addStudent: true,
        addAdmin: true,
        addSuperAdmin: true,
      },
      export: true,
      listItem: {
        view: true,
        edit: true,
        delete: true,
        statusChange: true
      }
    },
    eventManagement: {
      createEvent: true,
      export: true,
      listItem: {
        view: true,
        edit: true,
        delete: true,
        statusChange: true
      }
    },
    eventManagementView: {
      shareEmail: true,
      syncWithAsana: true,
      statusChange: true,
      edit: true,
      assignStudent: true,
      studentList: {
        edit: true,
        statusChange: true,
        mediaConsent: true,
      }
    },
    eventType: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    mccEventPartner: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    focusArea: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    audiance: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    region: {
      addNew: true,
      genarateReport: true,
      listItem: {
        edit: true,
        statusChange: true
      }
    },
    school: {
      addNew: true,
      export: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    schoolView: {
      edit: true,
      addItem: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
      }
    },
    teacher: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    teacherView: {
      edit: true,
      listItem: {
        view: true,
      }
    },
    student: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    studentView: {
      edit: true,
      schoolView: true,
      resetConsent: true,
      changeMediaConsent: true
    },
    report: {
      share: true,
      reportDashboard: true,
      eventTypeReport: true,
      eventReport: true,
      managerActivity: true,
      industryPartner: true,
      mccEvents: true,
      schoolEngagement: true,
    },
    csqTeam: {
      addNew: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    settings: {
      manage: {
        view: true,
        edit: true
      },
      reset: {
        view: true,
        edit: true
      }
    },
    faqCategories: {
      addNew: true,
      listItem: {
        edit: true,
        delete: true,
      }
    },
  },

  student: {
    home: {
      add: {
        addTeacher: false,
        addStudent: false,
        addSchool: false,
        addEvent: false,
        addCSQAdmin: false,
      }
    },
    userManagement: {
      add: {
        addCSQUser: false,
        addTeacher: false,
        addStudent: false,
        addAdmin: false,
        addSuperAdmin: false,
      },
      export: true,
      listItem: {
        view: true,
        edit: false,
        delete: false,
        statusChange: true
      }
    },
    eventManagement: {
      createEvent: false,
      export: true,
      listItem: {
        view: true,
        edit: false,
        delete: false,
        statusChange: false
      }
    },
    eventManagementView: {
      shareEmail: true,
      syncWithAsana: true,
      statusChange: true,
      edit: true,
      assignStudent: true,
      studentList: {
        edit: true,
        statusChange: true,
        mediaConsent: true,
      }
    },
    eventType: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    mccEventPartner: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    focusArea: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    audiance: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    region: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    school: {
      addNew: false,
      export: true,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    schoolView: {
      edit: true,
      addItem: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
      }
    },
    teacher: {
      addNew: false,
      export: true,
      bulkUpload: false,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    teacherView: {
      edit: true,
      listItem: {
        view: true,
      }
    },
    student: {
      addNew: false,
      export: true,
      bulkUpload: false,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    studentView: {
      edit: true,
      schoolView: true
    },
    report: {
      share: true,
      reportDashboard: false,
      eventTypeReport: false,
      eventReport: true,
      managerActivity: false,
      industryPartner: false,
      mccEvents: false,
      schoolEngagement: true,
    },
    csqTeam: {
      addNew: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    settings: {
      manage: {
        view: true,
        edit: true
      },
      reset: {
        view: true,
        edit: true
      }
    },
    faqCategories: {
      addNew: false,
      listItem: {
        edit: false,
        delete: false,
      }
    },
  },

  teacher: {
    home: {
      add: {
        addTeacher: false,
        addStudent: false,
        addSchool: false,
        addEvent: false,
        addCSQAdmin: false,
      }
    },
    userManagement: {
      add: {
        addCSQUser: false,
        addTeacher: false,
        addStudent: false,
        addAdmin: false,
        addSuperAdmin: false,
      },
      export: true,
      listItem: {
        view: true,
        edit: false,
        delete: false,
        statusChange: true
      }
    },
    eventManagement: {
      createEvent: false,
      export: true,
      listItem: {
        view: true,
        edit: false,
        delete: false,
        statusChange: false
      }
    },
    eventManagementView: {
      shareEmail: true,
      syncWithAsana: true,
      statusChange: true,
      edit: true,
      assignStudent: true,
      studentList: {
        edit: true,
        statusChange: true,
        mediaConsent: true,
      }
    },
    eventType: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    mccEventPartner: {
      addNew: false,
      genarateReport: false,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    focusArea: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    audiance: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    region: {
      addNew: false,
      genarateReport: true,
      listItem: {
        edit: false,
        statusChange: false
      }
    },
    school: {
      addNew: false,
      export: true,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    schoolView: {
      edit: true,
      addItem: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
      }
    },
    teacher: {
      addNew: false,
      export: true,
      bulkUpload: false,
      listItem: {
        edit: false,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    teacherView: {
      edit: true,
      listItem: {
        view: true,
      }
    },
    student: {
      addNew: true,
      export: true,
      bulkUpload: true,
      listItem: {
        edit: true,
        view: true,
        delete: false,
        statusChange: true
      }
    },
    studentView: {
      edit: true,
      schoolView: false
    },
    report: {
      share: true,
      reportDashboard: false,
      eventTypeReport: false,
      eventReport: true,
      managerActivity: false,
      industryPartner: false,
      mccEvents: false,
      schoolEngagement: true,
    },
    csqTeam: {
      addNew: true,
      listItem: {
        edit: true,
        view: true,
        delete: true,
        statusChange: true
      }
    },
    settings: {
      manage: {
        view: true,
        edit: true
      },
      reset: {
        view: true,
        edit: true
      }
    },
    faqCategories: {
      addNew: false,
      listItem: {
        edit: false,
        delete: false,
      }
    },
  },
}

